import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { GetDataForMapsResult } from "../masters/items/queries/types";

import MapsView from "./MapsView";
import { TableType } from "../../customer/companies/queries/types";

export interface MapProps {
  items: GetDataForMapsResult[];
  clusterer: React.MutableRefObject<MarkerClusterer | null>;
  selectedPlace: google.maps.places.PlaceResult | null;
  assetType: TableType;
  searchCoordinates: string
}
const MyMaps = ({ ...props }: MapProps) => {
  return (
    <div className="maps__flex--right--image">
      <MapsView {...props} />
    </div>
  );
};

export default MyMaps;
